// ***************************************
// tgfComponents.ComponentLobbyListItem
//
// This is an empty template for a new component
//
// Copyright 2015 Tingly Games B.V.
// Last Changed: 2592015
// ***************************************
import { tgfSettings } from "../tgfSettings";
import { ComponentBase } from "./ComponentBase";
import { ComponentContainer } from "./ComponentContainer";
import { ComponentPicture } from "./ComponentPicture";
import { tgfComponents } from "./tgfComponents";
// TODO: Everywhere replace Template and template by the appropriate name
// Directives for jslint
/*global tbEase, tbVectorFont, tbGraphics, tbImage, tbSurface, tbGame */
/*global tgfComponents, tgfScale, tgfEffects, tgfDictionary, tgfAudio, tgfSettings */
tgfSettings.componentDefaults.componentLobbyListItem = {
    isLast: false,
    nineSliceWidth: 0,
    sliceMargin: [],
    components: [] // Components to add as children
};
// The constructor for the component
/**
 * @constructor
 * @base tgfComponents.Base
 */
tgfComponents.ComponentLobbyListItem = function (properties) {
    "use strict";
    // console.log('ComponentLobbyListItem'); 
    this.name = "ComponentLobbyListItem"; // The name of the component
    // Initialize properties
    this.initialize(tgfSettings.componentDefaults.componentLobbyListItem);
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
};
export var ComponentLobbyListItem = tgfComponents.ComponentLobbyListItem;
// Inherit the base component
tgfComponents.inherit(tgfComponents.ComponentLobbyListItem, ComponentBase);
// ***************************************
// Size information (e.g. for design support)
// TODO: Override these when not default
// ***************************************
/*
// Returns the width of the component. Must be overriden if it is not the width property
tgfComponents.ComponentLobbyListItem.prototype.getWidth = function() {
   "use strict";
   return this.width === undefined ? 0 : this.width;
};

// Returns the height of the component. Must be overriden if it is not the height property
tgfComponents.ComponentLobbyListItem.prototype.getHeight = function() {
   "use strict";
   return this.height === undefined ? 0 : this.height;
};

// Returns the left position of the component (in its own coordinate system). Must be overriden if it is not centered
tgfComponents.ComponentLobbyListItem.prototype.getLeft = function() {
   "use strict";
   return -this.getWidth() / 2;
};

// Returns the top position of the component (in its own coordinate system). Must be overriden if it is not centered
tgfComponents.ComponentLobbyListItem.prototype.getTop = function() {
   "use strict";
   return -this.getHeight() / 2;
};
*/
// ***************************************
// Specific methods for this component
// ***************************************
// ***************************************
// Internal methods
// ***************************************
// ***************************************
// Preparing, showing and activating
//       These can be removed if no processing is required
// ***************************************
// Processing required when preparing the component for use
tgfComponents.ComponentLobbyListItem.prototype.doPrepare = function () {
    "use strict";
    var i;
    if (this.image) {
        if (this.isItemNineSliced) {
            this.background = new ComponentPicture({
                createFromSlices: true,
                sliceMarginsArray: this.sliceMargin,
                width: this.nineSliceWidth,
                x: -Math.round(this.nineSliceWidth / 2),
                y: 0,
                image: this.image
            });
        }
        else {
            this.background = new ComponentPicture({
                x: -Math.round(this.image.width / 2), y: 0, image: this.image
            });
        }
        this.components.push(this.background);
    }
    this.container = new ComponentContainer({ x: -Math.round(this.image.width / 2), y: 0, width: Math.round(this.image.width), height: Math.round(this.image.height) });
    this.components.push(this.container);
    if (this.data != undefined) {
        this._parseData();
    }
    // Add the child components
    if (this.components) {
        for (i = 0; i < this.components.length; i += 1) {
            this.addComponent(this.components[i]);
        }
    }
};
tgfComponents.ComponentLobbyListItem.prototype._parseData = function () {
};
tgfComponents.ComponentLobbyListItem.prototype.doPrepareAfterComponentsAdded = function () {
    // skin component here 
};
// Processing required when freeing the component from use
tgfComponents.ComponentLobbyListItem.prototype.doFree = function () {
    "use strict";
};
// Processing required when showing the component
tgfComponents.ComponentLobbyListItem.prototype.doShow = function () {
    "use strict";
};
// Processing required when hiding the component
tgfComponents.ComponentLobbyListItem.prototype.doHide = function () {
    "use strict";
};
// Processing required when activating the component
tgfComponents.ComponentLobbyListItem.prototype.doActivate = function () {
    "use strict";
};
// Processing required when deactivating the component
tgfComponents.ComponentLobbyListItem.prototype.doDeactivate = function () {
    "use strict";
};
// ***************************************
// Methods called when events must be processed
//       These can be removed when no processing is required
//       When they return true, this event is no further processed
//          by other components in the dialog
//       Never call these methods yourself in other components,
//          Use the inherited handle methods instead
// ***************************************
// Called at the beginning of each step
tgfComponents.ComponentLobbyListItem.prototype.doBeginStep = function (timePassed) {
    "use strict";
};
// Called when a touch is started or if a mouse button is pressed
tgfComponents.ComponentLobbyListItem.prototype.doTouchDown = function (finger, x, y) {
    "use strict";
};
// Called when a touch is ended or if a mouse button is released
tgfComponents.ComponentLobbyListItem.prototype.doTouchUp = function (finger, x, y) {
    "use strict";
};
// Called when the position of the mouse wheel is changed
tgfComponents.ComponentLobbyListItem.prototype.doMouseWheel = function (delta, x, y) {
    "use strict";
};
// Called immediately when a touch is started or if a mouse button is pressed
tgfComponents.ComponentLobbyListItem.prototype.doImmediateTouchDown = function (finger, x, y) {
    "use strict";
};
// Called immediately when a touch is ended or if a mouse button is released
tgfComponents.ComponentLobbyListItem.prototype.doImmediateTouchUp = function (finger, x, y) {
    "use strict";
};
// Called if the key with the given keyCode is pressed
tgfComponents.ComponentLobbyListItem.prototype.doKeyDown = function (keyCode) {
    "use strict";
};
// Called if the key with the given keyCode is released
tgfComponents.ComponentLobbyListItem.prototype.doKeyUp = function (keyCode) {
    "use strict";
};
// Called if a global alarm is reached
tgfComponents.ComponentLobbyListItem.prototype.doAlarm = function (alarm) {
    "use strict";
};
// Called if a special or userdefined event happens
tgfComponents.ComponentLobbyListItem.prototype.doSpecial = function (id, args) {
    "use strict";
};
// Called at the end of each step
tgfComponents.ComponentLobbyListItem.prototype.doEndStep = function (timePassed) {
    "use strict";
};
// Called just before drawing (also when not active)
tgfComponents.ComponentLobbyListItem.prototype.doUpdateVisuals = function (timePassed) {
    "use strict";
};
// Called when the component must be drawn (relative to position 0, 0)
tgfComponents.ComponentLobbyListItem.prototype.doDraw = function () {
    "use strict";
};
// Called after drawing the subcomponents
tgfComponents.ComponentLobbyListItem.prototype.doEndDraw = function () {
    "use strict";
};
